import { Collaborator } from 'types';

export const getInitials = (collaborator: Collaborator | undefined): string => {
  return `${collaborator?.firstName[0] || ''}${
    collaborator?.lastName[0] || ''
  }`;
};
